import { preloader } from './helpers/preloader';
import { isMobile } from './helpers/isMobile';
import { analyticsCompareProductListener } from './analytics/listeners/externallyTriggeredEvents';

/**
 * Compare products component. Displays 2 products on mobile, 3 on tablet and 4 on desktop screens.
 * On product change calls service that returns new component HTML.
 */
window.HMSCompareProducts = class CompareProducts {
  constructor() {
    this.$window = $(window);
    this.$filtersContainer = $('.js-compare-products-filters-container');
    this.initialSelectedProducts = [];
    this.resetToInitialCalled = false;
    this.resetTriggerCount = 0;

    if (this.$filtersContainer.length) {
      this.initialTopPosition = this.$filtersContainer.offset().top - $('.js-menu').height();
      this.$compareDropdown = $('.js-compare-products-filter-dropdown');
      this.cacheInitialSelectedProducts();

      this.init();
    }
  }

  /**
   * Cache initial selected products on page load.
   * The selection can be used to reset to initial selection.
   */
  cacheInitialSelectedProducts() {
    $.each(this.$compareDropdown, (index, dropdown) => {
      this.initialSelectedProducts.push(dropdown.value);
    });
  }

  /**
   * Reset filters to initial cached state.
   */
  resetToInitialSelection() {
    this.resetToInitialCalled = true;
    $.each(this.$compareDropdown, (index, dropdown) => {
      $(dropdown).val(this.initialSelectedProducts[index]);
    });
    this.$compareDropdown.trigger('change');
  }

  /**
   * Toggles a class to make dropdowns sticky on top of the page.
   * Adds a css top property when sticky.
   */
  toggleStickyDropdowns() {
    const isSticky = this.$window.scrollTop() > this.initialTopPosition;

    const calculateTopPosition = () => {
      if (!isSticky) {
        return 'initial';
      }

      if (isMobile()) {
        return $('#mainheader').height() + 40;
      }

      return $('.js-menu').height();
    };

    this.$filtersContainer
      .toggleClass('compare-products-filters-container--is-sticky', isSticky)
      .css('top', calculateTopPosition());

    $('.js-compare-products-list').css('marginTop', isSticky ?
      this.$filtersContainer.height() + 20 : 0);
  }

  /**
   * When some product is changed from the dropdown a service is called.
   * The service returns a new HTML for whole component.
   * @param {Event} event - Select
   */
  changeProductSelection(event) {
    const $changedDropdown = $(event.currentTarget);
    const selectedValue  = $changedDropdown.val();

    /**
     * Changing the value of the select to display label 'Please select a product'
     */
    if (selectedValue === 'reset') {
      $changedDropdown
        .val('')
        .trigger('change');

      return;
    }

    /**
     * Waits for a change to be made to all 4 dropdowns
     * before calling the API.
     */
    if (this.resetToInitialCalled) {
      this.resetTriggerCount += 1;
      if (this.resetTriggerCount < 4) {
        return;
      }

      this.resetToInitialCalled = false;
      this.resetTriggerCount = 0;
    }

    const selectedProducts = [];
    $.each(this.$compareDropdown, (index, dropdown) => {
      selectedProducts.push(dropdown.value);
    });

    preloader($('.js-compare-products-list'), true);

    $.ajax({
      url: $('#compareProductsUrl').val(),
      type: 'GET',
      traditional: true,
      data: {
        segment: $('#compareProductsSegment').val(),
        segmentDirectory: $('#compareProductsSegmentDirectory').val(),
        componentId: $('#compareProductsComponentId').val(),
        selectedProducts
      },
      success: data => $('.js-compare-products-replace-content').html(data),
      error: data => $('.js-compare-products-replace-content').html(data)
    });

    analyticsCompareProductListener(selectedValue, $changedDropdown.find(':selected').text());
  }

  /**
   * Inits dropdowns. Toggles sticky dropdowns on scroll and window resize.
   */
  init() {
    this.$compareDropdown.select2({dropdownParent: $('.compare-products-filters')});
    this.$compareDropdown.on('change', (event) => this.changeProductSelection(event));
    this.$window.scroll(() => this.toggleStickyDropdowns());
    this.$window.resize(() => this.toggleStickyDropdowns());
    $('.js-compare-product-reset').on('click', () => this.resetToInitialSelection());
  }
};
